// extracted by mini-css-extract-plugin
module.exports = {"title":"Confirm_title__3YhNI"};